import mountNecessityAndProportionalityParams from './mountNecessityAndProportionalityParams'

export default {
  mountNecessityAndProportionalityParams,
}
